import {
  Input,
  InputField,
  InputLabel,
  InputRoot,
  InputWrapper,
} from '@kustom-checkout/morpheus';

interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  state?: 'default' | 'error' | 'warning';
}

export function TextField({
  id,
  label,
  value,
  onChange,
  onBlur,
  disabled,
  state = 'default',
}: TextFieldProps) {
  return (
    <InputRoot
      id={id}
      state={state}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
    >
      {/* Morpheus outlines fields at 48% for checkout, where a field is the
          main event. Here they are a sidebar, so soften to the muted token. */}
      <InputField className={state === 'default' ? 'border-outline-muted' : ''}>
        <InputWrapper>
          {/* Morpheus renders label and value identically — same colour, same
              weight — which reads harsh and gives the two no hierarchy. The
              label is secondary to the value it describes, so mute it. */}
          <InputLabel className="text-on-surface-muted font-normal">
            {label}
          </InputLabel>
          <Input className="font-normal" onBlur={onBlur} />
        </InputWrapper>
      </InputField>
    </InputRoot>
  );
}
